import { getStoreBuilder } from 'vuex-typex'
import { FeedState } from './state'
import { RootState } from '..'
import { IUser } from '@/model/user'
import authStore from '../auth/auth-store'
import viewStatements from './actions/view-statements'
import viewConvos from './actions/view-convos'
import viewMyStatements from './actions/view-my-statements'
import viewMyConvos from './actions/view-my-convos'
import editConvo from './actions/edit-convo'
import newConvo from './actions/new-convo'
import newStatement from './actions/new-statement'
import setFeedUser from './actions/set-feed-user'
import editConvoStatements from '@/store/feed/actions/edit-convo-statements';
import editCommentStatements from '@/store/feed/actions/edit-comment-statements';
import setFeedPage from '@/store/feed/actions/set-feed-page';
import initFeed from '@/store/feed/actions/init-feed';

const initialState: FeedState = {
  feedType: 'statement-feed',
  columns: 2,
  editType: 'none',
  feedUser: null,
  feedId: null,
  feedUserId: null,
  isCurrent: false,
  isInitialized: false
}

const storeBuilder = getStoreBuilder<RootState>()
const moduleBuilder = storeBuilder.module<FeedState>('feed', initialState)
const stateReader = moduleBuilder.state()

const feedStore = {
  get state () { return stateReader() },

  get feedUser () { return this.state.feedUser },

  get isCurrentUser () { return this.state.isCurrent },

  get feedId () { return this.state.feedId },

  get feedUserId () { return this.state.feedUserId },

  get isInitialized () { return this.state.isInitialized },

  commitSetFeedType: moduleBuilder.commit((state: FeedState, payload: { type: string, columns: number }) => {
    state.feedType = payload.type
    state.columns = payload.columns
  }, 'setType'),
  commitSetUserId: moduleBuilder.commit((state: FeedState, payload: { id: string | null }) => {
    state.isInitialized = true
    state.feedUserId = payload.id
    state.isCurrent =(authStore.user && authStore.user.id && authStore.user.id.toString() === payload.id) ? true : false
  }, 'setUserId'),
  commitSetUser: moduleBuilder.commit((state: FeedState, payload: { user: IUser | null }) => {
    state.isInitialized = true
    state.feedUser = payload.user
    state.isCurrent =(state.feedUser && authStore.user && state.feedUser.id === authStore.user.id) ? true : false
  }, 'setUser'),
  commitSetFeed: moduleBuilder.commit((state: FeedState, payload: { feedType: string, feedId: string|null|undefined, feedUserId: string|null|undefined }) => {
    state.feedType = payload.feedType
    state.feedId = payload.feedId
    state.feedUserId = payload.feedUserId
  }, 'setPage'),

  dispatchViewStatements: moduleBuilder.dispatch(viewStatements),
  dispatchViewConvos: moduleBuilder.dispatch(viewConvos),
  dispatchViewMyStatements: moduleBuilder.dispatch(viewMyStatements),
  dispatchViewMyConvos: moduleBuilder.dispatch(viewMyConvos),
  dispatchNewConvo: moduleBuilder.dispatch(newConvo),
  dispatchEditConvo: moduleBuilder.dispatch(editConvo),
  dispatchEditConvoStatements: moduleBuilder.dispatch(editConvoStatements),
  dispatchEditCommentStatements: moduleBuilder.dispatch(editCommentStatements),
  dispatchNewStatement: moduleBuilder.dispatch(newStatement),
  dispatchSetFeedUser: moduleBuilder.dispatch(setFeedUser),
  dispatchInitFeed: moduleBuilder.dispatch(initFeed),
  dispatchSetFeedPage: moduleBuilder.dispatch(setFeedPage)
}

export default feedStore
